import { render } from "./StatGrid.vue?vue&type=template&id=6f3e1185&scoped=true"
import script from "./StatGrid.vue?vue&type=script&lang=js"
export * from "./StatGrid.vue?vue&type=script&lang=js"

import "./StatGrid.vue?vue&type=style&index=0&id=6f3e1185&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3e1185"]])

export default __exports__